<template>
  <b-modal
    v-model="showDialogDuplicateUser"
    centered
    size="md"
    no-close-on-backdrop
    header-text-variant="warning"
    hide-header-close
    scrollable
    headerClass="border-bottom-0 pb-0"
    footerClass="border-top-0 "
    body-class="pt-0"
  >
    <template v-slot:modal-title>
      <h5>Possible client duplication</h5>
    </template>

    <template v-slot:modal-footer="{}"
      ><b-button size="sm" variant="secondary" @click="cancel()">
        Cancel
      </b-button>
    </template>
    <p style="font-size: 14px;">
      <b
        >You may be entering a duplicate patient, we found this/these patient(s)
        with matching information:</b
      >
    </p>

    <div v-for="(user, index) in possibleUsersDuplicates" :key="index">
      <b-card body-class="pt-2 pb-2 pl-4">
        <b-row>
          <b-col cols="10">
            <b-row>
              {{ user.mrn }} {{ user.firstName }} {{ user.lastName }}
            </b-row>
            <b-row> {{ user.dateOfBirth | formatDateOnly }} </b-row>
            <b-row>
              {{
                user.phone.length > 2
                  ? user.email + ", " + user.phone
                  : user.email
              }}
            </b-row>
          </b-col>
          <b-col cols="2">
            <b-row class="pt-3">
              <b-button variant="link" @click="addUser(user.id)"
                ><b>Select</b></b-button
              >
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <br />
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "EocPossibleDuplications",

  props: ["possibleUsersDuplicates"],
  data() {
    return {};
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    addUser(idUser) {
      this.$emit("addUser", idUser);
    }
  },
  computed: {
    showDialogDuplicateUser: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
